module.exports = __webpack_public_path__ + "flags.cb057877085d8ef838b8.png";


//////////////////
// WEBPACK FOOTER
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/assets/img/flags/flags.png
// module id = ../../../../../src/assets/img/flags/flags.png
// module chunks = styles